import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useRef, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { Popover } from "@reach/popover";
import { SliderGlobal, SliderInputImpl, SliderTrackImpl, SliderTrackHighlightImpl, SliderHandleImpl, SliderValueDisplay } from "./slider.styles.es.js";
import { positionTopCenter } from "../../utils/popover-position.es.js";
import { deprecated } from "../../prop-types-validators/deprecated.es.js";
const propTypes = {
  disabled: PropTypes.bool,
  hideHandle: PropTypes.bool,
  hideTrack: PropTypes.bool,
  highlightTrack: PropTypes.bool,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  showHandle: deprecated(PropTypes.bool),
  showTrack: deprecated(PropTypes.bool),
  step: PropTypes.number,
  value: PropTypes.number
};
const defaultProps = {
  disabled: false,
  hideHandle: false,
  hideTrack: false,
  highlightTrack: false,
  showHandle: void 0,
  showTrack: void 0,
  step: 1,
  value: void 0
};
const Slider = ({
  disabled,
  hideHandle,
  hideTrack,
  highlightTrack,
  max,
  min,
  onChange,
  showHandle: showHandleProp = true,
  showTrack: showTrackProp = true,
  step,
  value
}) => {
  const ref = useRef();
  const [hasHover, setHover] = useState(false);
  const [pointerDown, setPointerDown] = useState(false);
  const showHandle = !hideHandle && showHandleProp;
  const showTrack = !hideTrack && showTrackProp;
  const handleMouseEnter = useCallback(() => {
    setHover(true);
  }, []);
  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);
  const handlePointerDown = useCallback(() => {
    if (!disabled) {
      setPointerDown(true);
    }
  }, [disabled]);
  const handlePointerUp = useCallback(() => {
    setPointerDown(false);
  }, []);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(SliderGlobal, { disableUserSelect: pointerDown }),
    /* @__PURE__ */ jsx(
      SliderInputImpl,
      {
        disabled,
        max,
        min,
        onChange,
        onPointerDown: handlePointerDown,
        onPointerUp: handlePointerUp,
        step,
        value,
        children: (state) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxs(
            SliderTrackImpl,
            {
              disabled,
              style: !showTrack && { backgroundColor: "rgba(0,0,0,0)" },
              children: [
                !disabled && highlightTrack && /* @__PURE__ */ jsx(SliderTrackHighlightImpl, {}),
                /* @__PURE__ */ jsx(
                  SliderHandleImpl,
                  {
                    ref,
                    disabled,
                    hidden: !showHandle,
                    onMouseEnter: handleMouseEnter,
                    onMouseLeave: handleMouseLeave
                  }
                )
              ]
            }
          ),
          (pointerDown || hasHover) && showHandle && /* @__PURE__ */ jsx(Popover, { position: positionTopCenter, targetRef: ref, children: /* @__PURE__ */ jsx(SliderValueDisplay, { children: state.value }) })
        ] })
      }
    )
  ] });
};
Slider.propTypes = propTypes;
Slider.defaultProps = defaultProps;
export {
  Slider
};
